import React from 'react';
import {connect} from 'react-redux';
import {Grid} from 'react-bootstrap';
import OrderSummaryItem from '../store/StoreOrderSummaryItem';
import StoreCartDeliveryDate from '../../components/store/StoreCartDeliveryDate';
import OrderSummaryTotal from '../../components/store/StoreOrderSummaryTotal';
import {translate} from '../../i18n/translate';
import {CreditTypes} from '../../common/constants';
import {isEmptyObj} from '../../common/utils';
import {setShowUpdateRecurringModal} from "../../actions/store/recurringOrderActions";
import styles from "../../css/store/storeOrderSummary.less";

class OrderSummary extends React.Component {
    state = {};

    getCreditTitle = (items, title) => {
        if(items && items.length && this.props.creditsData.creditType === CreditTypes.CREDIT_BY_SHARE) {
            return (
                <div className="order-summary-fixed-items" id="orderSummaryCreditFixedItemsTitle">
                    <h4 className="items-group-title">{translate(title)}</h4>
                    <hr className="summary-item-divider"/>
                </div>
            )
        }
    };

    onClickUpdateRecurring = () => {
        this.props.setShowUpdateRecurringModal(true);
    };

    isEnableUpdateRecurring = () => {
        const orderedItems = this.props.orderedItems || {};
        return this.props.staticData.hasRecurringItems && !this.props.hideRecurring &&
            (((this.props.recurringOrder||{}).items || []).length > 0 ||
            orderedItems.creditFixedItems && orderedItems.creditFixedItems.length > 0 ||
            orderedItems.fixedItems && orderedItems.fixedItems.length > 0 ||
            orderedItems.creditEditableItems && orderedItems.creditEditableItems.length > 0 ||
            orderedItems.editableItems && orderedItems.editableItems.length > 0);
    };

    getRecurringLink = (readOnly) => {
        if(this.isEnableUpdateRecurring() && this.props.clientViewPort.isXs) {
            return(<div className="update-recurring-link-mobile" onClick={this.onClickUpdateRecurring}>{(!readOnly?"Update":"View") + " Recurring" }</div>);
        }
    };

    isCheckoutScreen = () => {
        return window.location.pathname.includes("checkout");
    };

    render() {
        const orderedItems = this.props.orderedItems || {};
        const totals = this.props.totals || {};
        const fixedTotal = totals.fixedTotal;
        const editableTotal = totals.editableTotal;
        const isCreditItemAsRegularItem = this.props.isCreditItemAsRegularItem;
        if (this.state.popup) {
            return this.popupMessage();
        }
        if (isEmptyObj(this.props.orderStatus)) {
            return null;
        } else {
            return (<div>
                {!this.props.clientViewPort.isXs ?
                    <StoreCartDeliveryDate orderDate={this.props.orderDate}
                                           nextDeliveryDate={this.props.nextDeliveryDate}
                                           multiplePickupSitesDates={this.props.multiplePickupSitesDates}
                                           creditItemLabel={this.props.creditItemLabel}
                                           enableRecurringLink={this.isEnableUpdateRecurring()}
                                           onClickUpdateRecurring={this.onClickUpdateRecurring}
                                           isCheckoutScreen={this.isCheckoutScreen()}
                                           isXs={this.props.clientViewPort.isXs}/>
                    : undefined
                }
                <div className="scroll">
                    {orderedItems.creditFixedItems && orderedItems.creditFixedItems.length || orderedItems.fixedItems && orderedItems.fixedItems.length?
                        <div><h4 className="items-group-title existing-order">{translate("Existing Order")}</h4>
                            < hr className="summary-item-divider existing-order"/></div>:undefined
                    }
                    {
                        orderedItems.creditFixedItems && orderedItems.creditFixedItems.length?
                            <div className="order-summary-fixed-items" id="orderSummaryCreditFixedItems">
                                {!this.props.isCreditItemAsRegularItem?<div>
                                        <h4 className="items-group-title">{translate("Items for") + " " + this.props.creditItemLabel}</h4>
                                        <hr className="summary-item-divider"/>
                                    </div>:undefined}
                                {!this.props.isCreditItemAsRegularItem ?
                                    orderedItems.creditFixedItems.map(item => {
                                    return (
                                        <OrderSummaryItem key={item.key} item={item} readonly={true}
                                                          creditsData={this.props.creditsData}/>
                                    )
                                }) : undefined}
                                {orderedItems.fixedItems && orderedItems.fixedItems.length && this.props.isCreditItemAsRegularItem ? undefined :
                                    <div>
                                        {this.getRecurringLink(true)}
                                        <Grid className="order-summary-total" id="orderSummaryTotal">
                                            <OrderSummaryTotal isCredit={!isCreditItemAsRegularItem}
                                                               orderTotal={isCreditItemAsRegularItem?totals.orderTotal:{creditsTotal: totals.creditFixedItems}}
                                                               readonly={true}/>
                                        </Grid>
                                    </div>
                                }
                            </div>
                            : undefined
                    }
                    {!this.props.isCreditItemAsRegularItem?this.getCreditTitle(orderedItems.fixedItems, "Items for Purchase"):undefined}
                    {orderedItems.fixedItems && orderedItems.fixedItems.length?
                        <div className="order-summary-fixed-items" id="orderSummaryFixedItems">
                            {this.props.isCreditItemAsRegularItem && orderedItems.creditFixedItems && orderedItems.creditFixedItems.length ?
                                <div>
                                    {orderedItems.creditFixedItems.map(item => {
                                        return (
                                            <OrderSummaryItem key={item.key} item={item} readonly={true}
                                                              creditsData={this.props.creditsData}/>
                                        )
                                    })}</div> : undefined
                            }
                            {orderedItems.fixedItems.map(item => {
                                return (
                                    <OrderSummaryItem key={item.key} item={item} readonly={true}
                                                      creditsData={this.props.creditsData}
                                    />
                                )
                            })}
                            {this.getRecurringLink(true)}
                            <Grid className="order-summary-total" id="orderSummaryTotal">
                                <OrderSummaryTotal orderTotal={fixedTotal}
                                                   readonly={true}/>
                            </Grid>
                        </div>
                        : undefined}
                    {
                        (orderedItems.creditFixedItems && orderedItems.creditFixedItems.length ||
                        orderedItems.fixedItems && orderedItems.fixedItems.length) &&
                        (orderedItems.creditEditableItems && orderedItems.creditEditableItems.length ||
                        orderedItems.editableItems && orderedItems.editableItems.length)?
                        <div>
                            <h4 className="items-group-title">{translate("Additional Order")}</h4>
                            <hr className="summary-item-divider"/>
                        </div>
                        : undefined}
                    {orderedItems.creditEditableItems && orderedItems.creditEditableItems.length ?
                        <div className="order-summary-items" id="orderSummaryCreditItems">
                            {!this.props.isCreditItemAsRegularItem ? <div>
                                <h4 className="items-group-title">{translate("Items for") + " " + this.props.creditItemLabel}</h4>
                                <hr className="summary-item-divider"/>
                            </div> : undefined}
                            {orderedItems.creditEditableItems.map(item => {
                                return (
                                    <OrderSummaryItem key={item.key} item={item} readonly={this.props.readonly}
                                                      creditsData={this.props.creditsData}/>
                                );
                            })}
                            {orderedItems.editableItems && orderedItems.editableItems.length && this.props.isCreditItemAsRegularItem ? undefined :
                                <div>
                                    {this.getRecurringLink(this.props.readonly)}
                                    <Grid className="order-summary-total" id="orderSummaryTotal">
                                        <OrderSummaryTotal isCredit={!isCreditItemAsRegularItem}
                                                           orderTotal={isCreditItemAsRegularItem?totals.orderTotal:{creditsTotal: totals.creditEditableItems}}
                                                           readonly={this.props.readonly}/>
                                    </Grid>
                                </div>}
                        </div>
                        : undefined
                    }
                    {!this.props.isCreditItemAsRegularItem?this.getCreditTitle(orderedItems.editableItems, "Items for Purchase"):undefined}
                    {orderedItems.editableItems && orderedItems.editableItems.length ?
                        <div className="order-summary-items" id="orderSummaryItems">
                            {orderedItems.editableItems.map(item => {
                                return (
                                    <OrderSummaryItem key={item.key} item={item} readonly={this.props.readonly}
                                                      creditsData={this.props.creditsData}/>
                                )
                            })}
                            {this.getRecurringLink(this.props.readonly)}
                            <Grid id="orderSummaryTotal" className={editableTotal.extraCostAmount ? "order-summary-total has-extra-cost" : "order-summary-total"}>
                                    <OrderSummaryTotal orderTotal={editableTotal}
                                                       totalPoints={totals.points}
                                                       readonly={this.props.readonly}/>
                            </Grid>
                        </div>
                        : undefined}
                    {(!orderedItems.fixedItems || !orderedItems.fixedItems.length) && (!orderedItems.editableItems || !orderedItems.editableItems.length)
                    && (!orderedItems.creditFixedItems || !orderedItems.creditFixedItems.length) && (!orderedItems.creditEditableItems || !orderedItems.creditEditableItems.length) ?
                        <div className="order-summary-empty-items"
                             id="orderSummaryEmptyItems">{translate('_StartAddingItems')}
                            <div className="cart-img">
                            </div>
                        </div>
                        : undefined}
                </div>
            </div>);
        }
    }
}

const mapStateToProps = (state) => {
    const summary = state.summary || {};
    const orderStatus = (state.orderStatus||{});
    return {
        clientViewPort: (state.clientViewPort || {}),
        staticData: state.staticData,
        activeOrder: orderStatus.activeOrder,
        canEditExistingOrder: summary.canEditExistingOrder,
        orderChanged: orderStatus.isChanged,
        nextDeliveryDate: summary.nextDeliveryDate,
        multiplePickupSitesDates: summary.multiplePickupSitesDates,
        extraCost: summary.extraCost,
        creditsData: (state.storeCreditsData || {}),
        orderedItems: orderStatus.orderedItems,
        totals: orderStatus.totals,
        orderStatus: orderStatus,
        isCreditItemAsRegularItem: state.staticData.isCreditItemAsRegularItem,
        creditItemLabel: state.staticData.creditItemLabel,
        recurringOrder:(state.recurringOrder||{})
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setShowUpdateRecurringModal: (showUpdateRecurringModal) => {
            dispatch(setShowUpdateRecurringModal(showUpdateRecurringModal));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);


// WEBPACK FOOTER //
// ./src/containers/common/OrderSummary.js